import { put, call } from 'redux-saga/effects';
import ExternalSettingsDataRepository from '../../../../data/repositories/ExternalSettingsDataRepository';
import ExternalSettingsRepository from '../../../repositories/ExternalSettingsRepository';
import { Types } from './actions';

export default function* saga(): any {
  try {
    yield put({ type: Types.GET_STUDENT_PORTAL_SETTINGS_REQUEST });
    const externalSettingsRepository: ExternalSettingsRepository =
      new ExternalSettingsDataRepository();
    const externalSettings = yield call(
      externalSettingsRepository.getStudentPortalSettings
    );
    if (!externalSettings) {
      throw new Error('No se pudo leer los datos de configuración.');
    }
    // se remueve datos estáticos
    yield put({
      type: Types.GET_STUDENT_PORTAL_SETTINGS_SUCCESS,
      data: {
        // ...externalSettings.studentPortal,
        ...JSON.parse(externalSettings.config)
      }
    });
  } catch (error) {
    yield put({
      type: Types.GET_STUDENT_PORTAL_SETTINGS_FAILURE,
      error: 'Ocurrió un error al momento de leer los datos del estudiante.'
    });
  }
}
